"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Button_1 = __importDefault(require("../Button"));
const IconType_1 = __importDefault(require("../enums/IconType"));
const OverLay_1 = __importDefault(require("./OverLay"));
const ResetPasswordEmailSent = (props) => {
    var _a;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "popup-container" },
            react_1.default.createElement("section", { className: "popup" },
                react_1.default.createElement("div", { className: "popup__close" },
                    react_1.default.createElement(Button_1.default, { label: "", type: "tertiary", icon: IconType_1.default.Cancel, state: "enabled", handlerFunction: props.closeFunction })),
                react_1.default.createElement("div", { className: "popup__content forgot-password-email-sent-popup" },
                    react_1.default.createElement("h2", { className: "forgot-password-email-sent-popup__header" }, "Password reset link sent!"),
                    react_1.default.createElement("p", { className: "forgot-password-email-sent-popup__text" },
                        "To the ", (_a = props.email) !== null && _a !== void 0 ? _a : "entered",
                        " email we have sent a link which help you to change your password."),
                    react_1.default.createElement("div", { className: "forgot-password-email-sent-popup__close-button" },
                        react_1.default.createElement(Button_1.default, { label: "Close", type: "primary", icon: IconType_1.default.None, state: "enabled", handlerFunction: props.closeFunction }))))),
        react_1.default.createElement(OverLay_1.default, null)));
};
exports.default = ResetPasswordEmailSent;
